/**
 * Created by andrey on 08.08.2025
 */

cc.Sequence = function (...args) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._split = undefined;
    this._last = 0;

    const paramArray = (args[0] instanceof Array) ? args[0] : [...args];
    const actions = [];
    if (paramArray.length > 0) {
        actions.push(paramArray[0]);
    }
    if (paramArray.length > 1) {
        actions.push(paramArray[1]);
    }
    for (let i = 2; i < paramArray.length; i++) {
        actions[0] = cc.Sequence.fromArray([actions[0], actions[1]]);
        actions[1] = paramArray[i];
    }
    this.initWithActions(actions);
};

cc.Sequence.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.Sequence,

    initWithActions: function (actions) {
        const duration = actions.reduce((total, action) => {
            if (!action) {
                throw new Error("cc.Sequence action is undefined");
            }
            return total + action._duration;
        }, 0);

        this.initWithDuration(duration);

        this._actions = actions;

        return true;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        if (this._actions.length > 0) {
            this._split = this._actions[0]._duration / this._duration;
        } else {
            this._split = 0;
        }
        this._last = -1;
    },

    stop: function () {
        // Issue #1305
        if (this._last !== -1) {
            this._actions[this._last].stop();
        }
        cc.Action.prototype.stop.call(this);
    },

    _autoFinalize: function () {
        if (this._actions.length === 0) {
            return;
        }
        const start = this._last === -1 ? 0 : this._last;
        for (let i = start; i < this._actions.length; i++) {
            if (i !== this._last) {
                this._actions[i].startWithTarget(this.target);
            }
            this._actions[i]._autoFinalize();
        }
        this._elapsed = this._duration;
    },

    update: function (dt) {
        let newt, found = 0;
        const split = this._split, actions = this._actions, last = this._last;

        if (this._actions.length === 0) {
            return;
        }

        dt = this._computeEaseTime(dt);
        if (dt < split || actions.length === 1) {
            // action[0]
            newt = (split !== 0) ? dt / split : 1;

            if (found === 0 && last === 1) {
                // Reverse mode ?
                // XXX: Bug. this case doesn't contemplate when _last==-1, found=0 and in "reverse mode"
                // since it will require a hack to know if an action is on reverse mode or not.
                // "step" should be overriden, and the "reverseMode" value propagated to inner Sequences.
                actions[1].update(0);
                actions[1].stop();
            }
        } else {
            // action[1]
            found = 1;
            newt = (split === 1) ? 1 : (dt - split) / (1 - split);

            if (last === -1) {
                // action[0] was skipped, execute it.
                actions[0].startWithTarget(this.target);
                actions[0].update(1);
                actions[0].stop();
            }
            if (!last) {
                // switching to action 1. stop action 0.
                actions[0].update(1);
                actions[0].stop();
            }
        }

        const actionFound = actions[found];
        // Last action found and it is done.
        if (last === found && actionFound.isDone()) {
            return;
        }

        // Last action found and it is done
        if (last !== found) {
            actionFound.startWithTarget(this.target);
        }

        actionFound.update(newt > 1 ? newt % 1 : newt);
        this._last = found;
    }
});

cc.sequence = function (...args) {
    const paramArray = (args[0] instanceof Array) ? args[0] : [...args];
    if ((paramArray.length > 0) && (paramArray[paramArray.length - 1] == null)) {
        console.log("parameters should not be ending with null in Javascript");
    }

    let result, current;
    while (paramArray && paramArray.length > 0) {
        current = Array.prototype.shift.call(paramArray);

        if (!result) {
            result = current;
        } else {
            result = cc.Sequence.fromArray([result, current]);
        }
    }

    return result;
};

cc.Sequence.fromArray = function (actions) {
    const sequence = new cc.Sequence();
    sequence.initWithActions(actions);
    return sequence;
};